module.exports = __webpack_public_path__ + "static/media/insta05.18e9d1b0.jpg";